var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.disabled && (!_vm.limit || _vm.fileList.length < _vm.limit)
        ? _c(
            "el-upload",
            _vm._b(
              {
                ref: "upload",
                attrs: {
                  headers: _vm.headers,
                  action: _vm.action,
                  multiple: false,
                  "file-list": _vm.fileList,
                  "before-upload": _vm.beforeUpload,
                  "on-success": _vm.successUpload,
                  "show-file-list": false,
                  "on-progress": _vm.progressUpload,
                  "on-error": _vm.errorUpload,
                  limit: _vm.limit,
                },
              },
              "el-upload",
              _vm.$attrs,
              false
            ),
            [
              _vm._t(
                "default",
                function () {
                  return [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "primary" } },
                      [_vm._v(_vm._s(_vm.btnText))]
                    ),
                  ]
                },
                { fileList: _vm.fileList }
              ),
              _vm._t("tip"),
            ],
            2
          )
        : _vm._e(),
      _vm.showFileList
        ? _c(
            "transition-group",
            {
              staticClass: "transition_container",
              attrs: { name: "fade", tag: "div" },
            },
            [
              _vm.showType === "list"
                ? _vm._t(
                    "fileList",
                    function () {
                      return [
                        _vm._l(_vm.fileList, function (item, index) {
                          return [
                            ["mp4"].includes(
                              _vm.Filter.formatFileTypeSuffix(item.accessUrl)
                            )
                              ? _c("video", {
                                  key: item.name,
                                  staticStyle: { margin: "10px 0" },
                                  attrs: {
                                    src: item.accessUrl,
                                    preload: "",
                                    width: "100%",
                                    height: "100px",
                                    controls: "",
                                  },
                                  on: {
                                    loadedmetadata: function (e) {
                                      return _vm.handleLoadVideo(e, item)
                                    },
                                  },
                                })
                              : _c(
                                  "div",
                                  { key: item.name, staticClass: "file_box" },
                                  [
                                    [
                                      "jpeg",
                                      "jpg",
                                      "png",
                                      "gif",
                                      "bmp",
                                      "JPEG",
                                      "JPG",
                                      "PNG",
                                      "GIF",
                                      "BMP",
                                    ].includes(
                                      _vm.Filter.formatFileTypeSuffix(
                                        item.accessUrl
                                      )
                                    )
                                      ? [
                                          _c("el-image", {
                                            ref: "elImage",
                                            refInFor: true,
                                            staticStyle: {
                                              width: "70px",
                                              height: "70px",
                                              cursor: "pointer",
                                            },
                                            attrs: {
                                              src: item.url,
                                              "preview-src-list":
                                                _vm.previewSrcList,
                                            },
                                          }),
                                        ]
                                      : [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "justify-content": "center",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "62px",
                                                  height: "70px",
                                                  cursor: "pointer",
                                                },
                                                attrs: { src: item.url },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handlePreview(
                                                      item
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                    _c(
                                      "div",
                                      {
                                        staticClass: "file_name",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePreview(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(" " + _vm._s(item.name) + " "),
                                        item.percentage && item.percentage < 100
                                          ? _c("el-progress", {
                                              attrs: {
                                                format: function (percentage) {
                                                  return (
                                                    Math.floor(percentage) + "%"
                                                  )
                                                },
                                                "stroke-width": 2,
                                                percentage: item.percentage,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    item.status == "success" && !_vm.disabled
                                      ? _c(
                                          "div",
                                          { staticClass: "success_status" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-close",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemove(
                                                    item,
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                          ]
                        }),
                      ]
                    },
                    { fileList: _vm.fileList }
                  )
                : _vm.showType === "picture"
                ? _vm._l(_vm.fileList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.name,
                        staticClass: "picture_box flex-center-center",
                      },
                      [
                        [
                          "jpeg",
                          "jpg",
                          "png",
                          "gif",
                          "bmp",
                          "JPEG",
                          "JPG",
                          "PNG",
                          "GIF",
                          "BMP",
                        ].includes(
                          _vm.Filter.formatFileTypeSuffix(item.accessUrl)
                        )
                          ? [
                              item.url
                                ? _c("el-image", {
                                    ref: "elImage",
                                    refInFor: true,
                                    attrs: {
                                      src: item.url,
                                      "preview-src-list": _vm.previewSrcList,
                                    },
                                  })
                                : _c(
                                    "el-avatar",
                                    { attrs: { shape: "square", size: 100 } },
                                    [_vm._v("上传中")]
                                  ),
                              item.status == "success" && !_vm.disabled
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "picture_box_action flex-center-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-zoom-in icon",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePreview(item)
                                          },
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-delete icon",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemove(item, index)
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "center",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "62px",
                                      height: "70px",
                                      cursor: "pointer",
                                    },
                                    attrs: { src: item.url },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePreview(item)
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                      ],
                      2
                    )
                  })
                : _vm._l(_vm.fileList, function (item, index) {
                    return _c(
                      "div",
                      { key: item.name, staticClass: "text_box flex-center" },
                      [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleShowOnlinePreview(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        item.percentage && item.percentage < 100
                          ? _c("span", { staticClass: "percentage" }, [
                              _vm._v(_vm._s(Math.floor(item.percentage)) + "%"),
                            ])
                          : _vm._e(),
                        item.percentage === 100 &&
                        item.status == "success" &&
                        !_vm.disabled
                          ? _c("i", {
                              staticClass: "el-icon-close icon",
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemove(item, index)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
            ],
            2
          )
        : _vm._e(),
      _c("OnlinePreview", {
        attrs: {
          src: _vm.onlinePreviewSrc,
          name: _vm.onlinePreviewName,
          suffix: _vm.onlinePreviewSuffix,
        },
        on: {
          onlinePreviewEvent: function ($event) {
            ;(_vm.onlinePreviewSrc = null), (_vm.onlinePreviewName = null)
          },
        },
        model: {
          value: _vm.onlinePreview,
          callback: function ($$v) {
            _vm.onlinePreview = $$v
          },
          expression: "onlinePreview",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }